// extracted by css-extract-rspack-plugin
module.exports =  {"otherCitiesWrap":"b6Xw1","btmLink":"k8D5A"};